import { AkaDurchgangId } from '../dtos.ts';

export function isAkaDurchgangId(akaDurchgangId: unknown): akaDurchgangId is AkaDurchgangId {
  return typeof akaDurchgangId === 'string' && (akaDurchgangId.startsWith('D') || akaDurchgangId.startsWith('E'));
}
